/**
 * Renders a TikTok campaign `operation_status` / `secondary_status`
 * enum as a colored pill. Matches the legacy `.status-active /
 * .status-paused / .status-deleted` badge styling so existing users
 * can scan the table at a glance.
 */

const STATUS_STYLES: Record<string, { label: string; cls: string }> = {
  ENABLE:  { label: "Active",  cls: "bg-green-900/40 text-green-300 border-green-600/40" },
  ACTIVE:  { label: "Active",  cls: "bg-green-900/40 text-green-300 border-green-600/40" },
  DISABLE: { label: "Paused",  cls: "bg-yellow-900/40 text-yellow-300 border-yellow-600/40" },
  PAUSED:  { label: "Paused",  cls: "bg-yellow-900/40 text-yellow-300 border-yellow-600/40" },
  UNKNOWN: { label: "Unknown", cls: "bg-gray-800/60 text-gray-300 border-gray-500/40" },
  DELETE:  { label: "Deleted", cls: "bg-red-900/40 text-red-300 border-red-600/40" },
  DELETED: { label: "Deleted", cls: "bg-red-900/40 text-red-300 border-red-600/40" },
}

export function StatusBadge({ status }: { status: string }) {
  const key = (status || "").toUpperCase()
  const meta = STATUS_STYLES[key] ?? {
    label: status || "—",
    cls: "bg-gray-800 text-gray-300 border-gray-600",
  }
  return (
    <span
      className={`inline-block rounded-full border px-1.5 py-0 text-[10px] font-semibold leading-4 ${meta.cls}`}
    >
      {meta.label}
    </span>
  )
}
